// @ts-nocheck
import { all, call, takeEvery, takeLatest } from 'redux-saga/effects';
import { api } from 'store/apis';

import { sendApi } from '../sagas';

import { settingsActions, settingsConstants } from './settings.actions';

function* settingsWatchers() {
  yield all([
    yield takeLatest(settingsConstants.addTwikey.request, sendApi(api.settings.addTwikey)),
    // template
    yield takeLatest(
      settingsConstants.templateListPage.request,
      sendApi(api.template.list, undefined, ({ callback, ...payload }) => ({
        data: payload,
        callback,
        noLoading: true,
      })),
    ),
    yield takeLatest(settingsConstants.templateList.request, sendApi(api.template.list, undefined)),
    // recovery plan
    yield takeEvery(settingsConstants.getRecoveryPlan.request, sendApi(api.recoveryPlan.detail)),
    yield takeLatest(settingsConstants.addRecoveryPlan.request, sendApi(api.recoveryPlan.add)),
    yield takeLatest(settingsConstants.setRecoveryPlan.request, sendApi(api.recoveryPlan.update)),
    yield takeLatest(
      settingsConstants.deleteRecoveryPlan.request,
      sendApi(api.recoveryPlan.delete),
    ),
    yield takeLatest(
      settingsConstants.duplicateRecoveryPlan.request,
      sendApi(api.recoveryPlan.duplicate),
    ),
    yield takeLatest(
      settingsConstants.getPlansInvoices.request,
      sendApi(api.recoveryPlan.getPlansInvoices),
    ),
    yield takeLatest(
      settingsConstants.switchPlansInvoices.request,
      sendApi(api.recoveryPlan.switchPlansInvoices, settingsActions.switchPlansInvoicesRes),
    ),
  ]);
}

export default function* saga() {
  yield call(settingsWatchers);
}
